import { REVEALED_CONTACT_EMPTY_DATA } from "../constants/revealed-contact-mock-data";
import type { ContactEntryPhone } from "../types/common";
import { ContactEntryType } from "../types/common";
import type { RevealedContactDto } from "../types/dto";

function getRevealedContactMockItem(
    hasValidEmails: boolean,
    hasDirectPhoneNumbers: boolean,
    hasMobilePhoneNumbers: boolean,
): RevealedContactDto {
    const mobile: ContactEntryPhone[] = hasMobilePhoneNumbers
        ? [
              {
                  ext: "",
                  number: "+1234567890",
                  type: "",
                  numberType: "",
                  internalType: ContactEntryType.Mobile,
              },
          ]
        : [];
    const direct: ContactEntryPhone[] = hasDirectPhoneNumbers
        ? [
              {
                  ext: "",
                  number: "+1234567890",
                  type: "",
                  numberType: "",
                  internalType: ContactEntryType.Direct,
              },
          ]
        : [];

    return {
        ...REVEALED_CONTACT_EMPTY_DATA,
        phoneNumbers: [...mobile, ...direct],
        emails: hasValidEmails ? ["contactExample@mail.com"] : [],
    };
}

export default getRevealedContactMockItem;
